import { createAction } from "redux-actions";

export const MONSTERS_ACTIONS = {
    TRANSFER_BY_ID: 'monsters transfer by id',
    ADD_IN_ZONE: 'monsters add in zone',
    MOVE_BY_ID: 'monsters move by id',
    RENAME_BY_ID: 'monsters rename by id',
    CAST_SPELL_BY_ID: 'monsters cast spell by id',
    TAKE_DAMAGE_BY_ID: 'monsters take damage by id',
    USE_ITEM: 'monsters use item'
};

export const monstersActions = {
    transferById: createAction(MONSTERS_ACTIONS.TRANSFER_BY_ID, (monsterId, actualZoneId, nextZoneId) => ({ monsterId, actualZoneId, nextZoneId })),
    addInZone: createAction(MONSTERS_ACTIONS.ADD_IN_ZONE, (monsterId, zoneId) => ({ monsterId, zoneId })),
    moveById: createAction(MONSTERS_ACTIONS.MOVE_BY_ID, (monsterId, x, y) => ({ monsterId, x, y })),
    renameById: createAction(MONSTERS_ACTIONS.RENAME_BY_ID, (monsterId, name) => ({ monsterId, name })),
    castSpellById : createAction(MONSTERS_ACTIONS.CAST_SPELL_BY_ID, (monsterId, amount) => ({ monsterId, amount })),
    takeDamageById : createAction(MONSTERS_ACTIONS.TAKE_DAMAGE_BY_ID, (monsterId, amount) => ({ monsterId, amount })),
    useItem: createAction(MONSTERS_ACTIONS.USE_ITEM, (monsterId, slotIndex) => ({ monsterId, slotIndex }))
};